module.exports = __webpack_public_path__ + "img/シャーローニ荒野.00a99f15.png";